import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { CurrencyCodeEnum } from '@rcsa-frontend/app/features/user/pages/reminder/reminder-contants';

@Directive({
  selector: '[appCurrencyCode]',
})
export class CurrencyCodeDirective implements OnChanges {
  @Input('appCurrencyCode') currency?: string;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (changes['currency']) {
      const codeSmall = this.renderer.createElement('small');
      this.renderer.addClass(codeSmall, 'small-currency-code');
      const existingSmall = this.el.nativeElement.querySelector(
        '.small-currency-code'
      );
      if (existingSmall) {
        this.renderer.removeChild(this.el.nativeElement, existingSmall);
      }

      const currencyCode = (
        this.currency || CurrencyCodeEnum.MXN
      ).toUpperCase();
      this.renderer.appendChild(
        codeSmall,
        this.renderer.createText(` ${currencyCode}`)
      );
      this.renderer.appendChild(this.el.nativeElement, codeSmall);
    }
  }
}
